import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';

import PersonSchema from 'src/lib/paths/person_FULL_Paths.json';
import UserSchema from 'src/lib/paths/user_Paths.json';
const PP = PersonSchema.attributes;
const UP = UserSchema.attributes;

const mailValidator = (val: string) => isEmail(val);
// const passwordValidator = (val: string) => isStrongPassword(val);

const AddPersonAndUserValidator = new Schema(
	{
		[PP.Personenbezogene_Daten_Anrede.path]: { type: String },
		[PP.Personenbezogene_Daten_Titel.path]: {
			type: String,
		},
		[PP.Personenbezogene_Daten_Vorname.path]: {
			type: String,
			required: true,
		},
		[PP.Personenbezogene_Daten_Nachname.path]: {
			type: String,
			required: true,
		},
		[PP.Kontaktdaten_E_Mail.path]: {
			type: String,
			required: true,
			use: { mailValidator },
			message: {
				mailValidator: 'Ungültige E-Mail-Adresse.',
			},
		},
		[PP.Kontaktdaten_Telefon.path]: {
			type: String,
			required: true,
			use: {
				phone: (val: string) => /^[0-9\s]*$/.test(val),
			},
			message: {
				phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
			},
		},
		[UP.username.path]: {
			type: String,
			required: true,
		},
		// [UP.email.path]: {
		// 	type: String,
		// 	required: true,
		// 	use: { mailValidator },
		// 	message: {
		// 		mailValidator: 'Ungültige E-Mail-Adresse.',
		// 	},
		// },
		// [UP.password.path]: {
		// 	type: String,
		// 	required: true,
		// 	use: { passwordValidator },
		// 	message: {
		// 		passwordValidator:
		// 			'Ihr Passwort sollte 8 Zeichen lang sein und mindestens ein Symbol, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.',
		// 	},
		// },
		// [UP.repeatPassword.path]: {
		// 	type: String,
		// 	required: true,
		// },
	},
	{ strip: false },
);

AddPersonAndUserValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichfeld',
	type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datantyp, ${path}" an`,
});

export default AddPersonAndUserValidator;
